import { BulkGridSelectionModeEnum } from "@ryde/shared";

export const getBulkGridSelectionModeLabelKey = (
  mode: BulkGridSelectionModeEnum,
): string => {
  switch (mode) {
    case BulkGridSelectionModeEnum.Page:
      return "general.SELECT_THIS_PAGE";
    case BulkGridSelectionModeEnum.Rows:
      return "general.SELECT_ROWS";
    default:
      return "general.SELECT_ALL_RESULTS";
  }
};
